<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="6 " md="5">
                    <h5 class="mt-2">{{Title}}</h5>
                  </b-col>
                  <b-col lg="6" md="7">
                    <catalog-search
                      showButtonText="View Filters"
                      placeholder="Search Goods Receipt Notes"
                      hideButtonText="Hide Filters"
                      v-on:show-cat="contentShow"
                      @value="getValue"
                      :isSearch="false"
                      :btnDisabled="checkBtnDisabled"
                      :searchDisabled="searchDisabled"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section v-show="isContentShow" class="fadein">
        <b-container fluid>
          <div class="customer-info table-dark-bg box-shadow mt-2 mb-3 p-4">
            <b-row>
              <b-col lg="3" class="text-left">
                <label for class="mb-0">Filter by Date</label>
                <b-form-select v-model="requestFilter.date" @change="filterData($event, 0)">
                  <option value>Anytime</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="last_7days">Last 7 Days</option>
                  <option value="last_month">Last 30 Days</option>
                  <option value="custom_range">Custom Range</option>
                </b-form-select>
                <!-- Select date range popup-->
                <b-modal ref="custom-range" hide-footer centered title="Select Date Range">
                  <div class="d-block">
                    <b-row>
                      <b-col>
                        <label for>Start Date</label>
                        <datepicker
                          placeholder="Select Date"
                          input-class="form-control"
                          v-model="startDate"
                        ></datepicker>
                      </b-col>
                      <b-col>
                        <label for>End Date</label>
                        <datepicker
                          placeholder="Select Date"
                          input-class="form-control"
                          v-model="endDate"
                        ></datepicker>
                      </b-col>
                    </b-row>
                  </div>

                  <b-button
                    class="btn grey-btn float-right px-4 mt-4"
                    :disabled="endDate==''"
                    @click="filterData($event, 0)"
                  >
                    <span v-if="$loading == false">Apply Filter</span>
                    <b-spinner small v-if="$loading == true"></b-spinner>
                  </b-button>
                </b-modal>
              </b-col>
              <b-col lg="3" class="text-left">
                <label for class="mb-0">Filter by Status</label>
                <b-form-select
                  v-model="requestFilter.status"
                  @change="filterData($event, 2)"
                  disabled
                >
                  <option value>Nothing Selected</option>
                  <option
                    v-for="status in filter.status"
                    :value="status"
                    v-text="status"
                    :key="status"
                  ></option>
                </b-form-select>
              </b-col>
              <b-col lg="3" class="text-left">
                <label for class="mb-0">Filter by Supplier</label>
                <v-select
                  :options="supplierList"
                  v-model="requestFilter.supplier"
                  class="custom-vselect-small"
                  :searchable="true"
                />
              </b-col>
              <b-col lg="3" class="text-left">
                <label for class="mb-0">Sort by</label>
                <b-form-select v-model="requestFilter.sort" @change="filterData($event,3)">
                  <option value>Nothing Selected</option>
                  <option
                    v-for="sort in filter.sort"
                    :value="sort.key"
                    v-text="sort.name"
                    :key="sort.key"
                  ></option>
                </b-form-select>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div v-bar>
            <div>
              <div class="customer-info table-dark-bg box-shadow p-2 mt-2 customer-info-data">
                <div v-if="GRNList.data">
                  <div
                    class="pill p-3 box-shadow mb-2 fade-in complete"
                    v-for="item in GRNList.data.grn_list"
                    :key="item.id"
                  >
                    <b-row class="align-items-center">
                      <div class="text-left pl-3 w-15">
                        <label for class="mb-0">GRN Number</label>
                        <p>{{item.grn_no}}</p>
                      </div>
                      <div class="text-left w-15">
                        <label for class="mb-0">GRN from</label>
                        <p>{{item.grn_from}}</p>
                      </div>
                      <div class="text-left w-15">
                        <label for class="mb-0">GRN Date</label>
                        <p>{{item.date}}</p>
                      </div>
                      <div class="text-left w-10">
                        <label for class="mb-0">Received Qty</label>
                        <p>{{item.received_qty}}</p>
                      </div>
                      <div class="text-left w-10">
                        <label for class="mb-0">Damaged Qty</label>
                        <p>{{item.damage_qty}}</p>
                      </div>
                      <div class="text-left w-10">
                        <label for class="mb-0">Lost Qty</label>
                        <p>{{item.lost_qty}}</p>
                      </div>
                      <div class="text-left w-15">
                        <label for class="mb-0">Remarks</label>
                        <p v-if="item.remarks==''">-</p>
                        <p v-else>{{item.remarks}}</p>
                      </div>
                      <div class="text-right w-9">
                        <b-btn
                          class="btn-theme"
                          title="View GRN"
                          @click="viewDetails(item.grn_no)"
                        >View GRN</b-btn>
                      </div>
                    </b-row>
                  </div>
                </div>

                <div
                  v-if="GRNList.data === undefined || GRNList.data.grn_list.length == 0"
                  class="d-flex align-items-center justify-content-center"
                  style="height:100%"
                >
                  <h5 v-if="$loading == false" class="fw-normal" style>No advices avaliable</h5>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import VSelect from "@alfsnd/vue-bootstrap-select";
import Dashboard from "../views/Dashboard";
import CatalogSearch from "../components/CatalogSearch";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "grnlist",
  components: {
    Dashboard,
    CatalogSearch,
    VSelect,
    Loading,
    Datepicker
  },
  mounted() {
    this.fetchGRN();
  },
  computed: {
    ...mapState({
      state: state => state,
      customerData() {
        return this.$store.getters["sessions/getCustomerParam"]
      },
      supplierList() {
        let data = [];
        data.push({ value: "", text: "Nothing Selected" });
        this.filter.supplier.map(item => {
          data.push({ value: item.id, text: item.name });
        });
        return data;
      }
    }),
    adviceList() {
      let result = this.GRNList.data.grn_list.filter(item => {
        if (item.grn_no == null) {
          item.grn_no = "";
        }
        return item;
      });
      if (!this.search) {
        return result;
      }

      const filterValue = this.search.toLowerCase();
      const filter = event => event.grn_no.toLowerCase().includes(filterValue);
      return result.filter(filter);
    },
    checkBtnDisabled() {
      if (this.GRNList == "") {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    "requestFilter.supplier": {
      handler(oldValue, newValue) {
        this.filterData(this.requestFilter.supplier.value, 1);
      }
    },
    "requestFilter.sort": {
      handler(oldValue, newValue) {
        this.filterData(this.requestFilter.sort.value, 3);
      }
    },
    deep: true
  },
  data() {
    return {
      Title: "GRN Listing",
      selected: null,
      loading: true,
      searchableName: true,
      isContentShow: false,
      search: "",
      startDate: "",
      fstartDay: "",
      fendDay: "",
      endDate: "",
      GRNList: [],
      filter: {
        status: [],
        supplier: [],
        sort: []
      },
      requestFilter: {
        date: "",
        status: "",
        supplier: "",
        sort: "",
        filter_format: []
      },
      searchDisabled: false
    };
  },
  methods: {
    contentShow(content) {
      this.isContentShow = content;
    },
    fetchGRN() {
      this.$loading = true;
      this.searchDisabled = true;
      var data = {
        c_id: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        terminal_id: this.state.system.settings.terminal_id,
        url:"/vendor/grn-list"
      };
      axios
        .post(data.url, data)
        .then(response => {
          this.GRNList = response.data;
          this.filter.status = response.data.filter.status;
          this.filter.supplier = response.data.filter.supplier;
          this.filter.sort = response.data.filter.sort;
          this.requestFilter.filter_format = response.data.filter.filter_format;
          this.$loading = false;
          this.searchDisabled = false;
        })
        .catch(err => {
          this.$loading = false;
          this.searchDisabled = false;
        });
    },

    filterData(event, num) {
      this.$loading = true;
      if (num != 0) {
        this.requestFilter.filter_format[num].value = event;
      } else {
        if (this.requestFilter.date == "") {
          this.requestFilter.filter_format[num].start_date = "";
          this.requestFilter.filter_format[num].end_date = "";
        } else if (this.requestFilter.date == "today") {
          let today = this.$moment().format("YYYY-MM-DD");
          this.requestFilter.filter_format[num].start_date = today;
          this.requestFilter.filter_format[num].end_date = today;
        } else if (this.requestFilter.date == "yesterday") {
          let today = this.$moment().format("YYYY-MM-DD");
          let yesterday = this.$moment()
            .subtract(1, "day")
            .format("YYYY-MM-DD");
          this.requestFilter.filter_format[num].start_date = yesterday;
          this.requestFilter.filter_format[num].end_date = today;
        } else if (this.requestFilter.date == "last_7days") {
          let today = this.$moment().format("YYYY-MM-DD");
          let lastsevendays = this.$moment()
            .subtract(7, "days")
            .format("YYYY-MM-DD");
          this.requestFilter.filter_format[num].start_date = lastsevendays;
          this.requestFilter.filter_format[num].end_date = today;
        } else if (this.requestFilter.date == "last_month") {
          let today = this.$moment().format("YYYY-MM-DD");
          let lastmonth = this.$moment()
            .subtract(1, "month")
            .format("YYYY-MM-DD");
          this.requestFilter.filter_format[num].start_date = lastmonth;
          this.requestFilter.filter_format[num].end_date = today;
        } else if (this.requestFilter.date == "custom_range") {
          this.$refs["custom-range"].show();
          if (this.endDate != "") {
            let startdate = this.$moment(this.startDate).format("YYYY-MM-DD");
            let finalstartday = startdate;
            let enddate = this.$moment(this.endDate).format("YYYY-MM-DD");
            let finalendday = enddate;
            this.requestFilter.filter_format[num].start_date = finalstartday;
            this.requestFilter.filter_format[num].end_date = finalendday;
            this.startDate = "";
            this.endDate = "";
            this.$refs["custom-range"].hide();
          }
        }
      }
      var data = {
        c_id: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        terminal_id: this.state.system.settings.terminal_id,
        filter: JSON.stringify(this.requestFilter.filter_format),
        url:"/vendor/grn-list"
      };
      axios
        .post(data.url, data)
        .then(response => {
          this.GRNList = response.data;
          this.filter.status = response.data.filter.status;
          this.filter.supplier = response.data.filter.supplier;
          this.filter.sort = response.data.filter.sort;
          // this.requestFilter.filter_format = response.data.filter.filter_format;
          this.$loading = false;
        })
        .catch(err => {
          this.$loading = false;
        });
    },
    getValue(value) {
      this.search = value;
    },
    clearSearch() {
      this.search = "";
    },

    viewDetails(grn_no) {
      this.$router.push("/grn-detail/" + grn_no);
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-select {
  font-size: 13px;
}
.theme-light .customer-info-data {
  background: $grey-btn-bg;
  height: calc(100vh - 69px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}

.theme-dark .customer-info-data {
  background: #202020 !important;
  height: calc(100vh - 69px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}

.text-muted {
  color: #c0c0c0 !important;
}
h5 {
  color: $grey-color;
}
.pill {
  border-radius: 5px;
  position: relative;
  &:before {
    width: 7px;
    height: 100%;
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
}
h4 {
  color: $mid-grey;
}
.complete h6 {
  color: $success-btn;
}
.partial h6 {
  color: #c0c0c0;
}
.pending h6 {
  color: $danger-btn;
}

.pending.pill {
  &:before {
    background: $danger-btn;
  }
}
.partial.pill {
  &:before {
    background: $dark-card-text;
  }
}
.complete.pill {
  &:before {
    background: $theme-color;
  }
}
.advice .customer-info-data {
  background: #202020 !important;
}
</style>